// extracted by mini-css-extract-plugin
module.exports =  {"btn-custom-order-request":"t7eo4nD","btnCustomOrderRequest":"t7eo4nD"};